import CasinoReportPage from "./casino-report-page";

export default CasinoReportPage